// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .add-on-after {
  float: right;
}

.form-control {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  display: none;
}
.form-control + label {
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  width: 100%;
  height: 36px;
  padding: 0;
  font-size: 16px;
  line-height: 1.42857;
  color: #555555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  margin-bottom: -5px;
}
.form-control + label span {
  min-height: 2em;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: top;
}
.form-control + label strong {
  height: 100%;
  color: white;
  background-color: #1E95D3;
  display: block;
  float: right;
}
.form-control + label[disabled] span {
  background-color: #eee;
}
.form-control:focus + label, .form-control.has-focus + label {
  border-color: #66afe9;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}

.form-control + label span,
.form-control + label strong {
  padding: 0.4rem 0.675rem;
}

.form-control:focus + label strong,
.form-control.has-focus + label strong,
.form-control + label:hover strong {
  background-color: #1E95D3;
}

@media screen and (max-width: 50em) {
  .form-control + label strong {
    display: block;
  }
}
.preview-image {
  max-height: 100px;
  margin: 5px;
}

.has-error .upload-false-label {
  border-color: #a94442;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}`, "",{"version":3,"sources":["webpack://./src/gamma/form/formquestion/bootstrap/fileupload/fileupload.component.scss"],"names":[],"mappings":"AAEI;EACI,YAAA;AADR;;AAKA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAFJ;AAII;EACI,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EAEA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gDAAA;EACA,wEAAA;EACA,mBAAA;AAHR;AAKQ;EACI,eAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;AAJZ;AAQY;EACI,sBAAA;AANhB;AAWI;EAEI,qBAAA;EACA,UAAA;EACA,kFAAA;AAVR;;AAcA;;EAEI,wBAAA;AAXJ;;AAcA;;;EAGI,yBAAA;AAXJ;;AAcA;EACC;IACC,cAAA;EAXA;AACF;AAcA;EACI,iBAAA;EACA,WAAA;AAZJ;;AAeA;EACI,qBAAA;EAEA,gDAAA;AAZJ","sourcesContent":["\n:host {\n    ::ng-deep .add-on-after {\n        float: right;\n    }\n}\n\n.form-control {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n    display: none;\n\n    + label {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        cursor: pointer;\n        display: inline-block;\n        overflow: hidden;\n\n        width: 100%;\n        height: 36px;\n        padding: 0;\n        font-size: 16px;\n        line-height: 1.42857;\n        color: #555555;\n        background-color: #fff;\n        background-image: none;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n        margin-bottom: -5px;\n\n        span {\n            min-height: 2em;\n            display: block;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n            vertical-align: top;\n        }\n\n        strong {\n            height: 100%;\n            color: white;\n            background-color: #1E95D3;\n            display: block;\n            float: right;\n        }\n\n        &[disabled] {\n            span {\n                background-color: #eee;\n            }\n        }\n    }\n\n    &:focus + label,\n    &.has-focus + label {\n        border-color: #66afe9;\n        outline: 0;\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n    }\n}\n\n.form-control + label span,\n.form-control + label strong {\n    padding: 0.4rem 0.675rem;\n\n}\n.form-control:focus + label strong,\n.form-control.has-focus + label strong,\n.form-control + label:hover strong {\n    background-color: #1E95D3;\n}\n\n@media screen and (max-width: 50em) {\n\t.form-control + label strong {\n\t\tdisplay: block;\n\t}\n}\n\n.preview-image {\n    max-height: 100px;\n    margin: 5px;\n}\n\n.has-error .upload-false-label {\n    border-color: #a94442;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
